import React from 'react';
import { useAppDispatch, useAppSelector } from '../hooks';
import { updateNodePageSelection } from '../reducer';

function classNames(...classes: any) {
  return classes.filter(Boolean).join(' ')
}

const navigation = [
  { name: 'About', href: '#', key: 'about' ,current: false },
  { name: 'Become A Node Runner', href: '#', current: true, key: 'joinnr', },
  { name: 'Stop Providing Feeds', href: '#' , current: false, key: 'leavenr',}
]


export default function FeedSideBar() {
  const dispatch = useAppDispatch();
  const pageSelection = useAppSelector(state => state.subscription.nodePageSelection);

  return (
    <div className="flex flex-col basis-1/4 border-r border-gray-200 pt-5 pb-4 bg-white overflow-y-auto">
      <div className=" flex-grow flex flex-col">
        <nav className="mt-5 flex-1 px-2 space-y-1 bg-white" aria-label="Sidebar">
          {navigation.map((item) =>
            <div key={item.name}>
              <a
                onClick={() => dispatch(updateNodePageSelection(item.key))}
                className={classNames(
                  item.key === pageSelection
                    ? 'bg-gray-100 text-gray-900'
                    : 'bg-white text-gray-600 hover:bg-gray-50 hover:text-gray-900',
                  'group w-full flex items-center pl-7 pr-2 py-2 text-sm font-medium rounded-md'
                )}
              >
                {item.name}
              </a>
            </div>
          )}
        </nav>
      </div>
    </div>
  );
}
